module.exports = __webpack_public_path__ + "static/media/linkedin.0b000652.svg";